module.exports = __webpack_public_path__ + "dfca99f4e4f677852d531b325ad8ded3.png";